
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { IWorkcenter } from '@/utils/types/model/workcenter'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  width?: number
}

@Options({
  name: 'WorkcenterList',
  emits: ['sort-change'],
})
export default class WorkcenterList extends Vue {
  @Prop({ type: Array, default: () => [] }) workcentersData!: IWorkcenter[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'workCenterCode', label: this.$t('workcenters.workcenter_code'), sortable: 'custom' },
      { prop: 'workCenterName', label: this.$t('workcenters.workcenter_name'), sortable: 'custom' },
      { prop: 'vendorCode', label: this.$t('workcenters.vendor_code') },
      { prop: 'wipWarehouse', label: this.$t('workcenters.wip_warehouse') },
      { prop: 'companyCode', label: this.$t('workcenters.company_code'), width: 150 },
    ]
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
